export default {
    "USER": {
        "NAME": "Felhasználónév",
        "PASSWORD": "Jelszó",
        "NEW_PASSWORD": "Új jelszó",
        "PASSWORD_CONFIRMATION": "Jelszó ismétlése",
        "LANGUAGE": "Nyelv",
        "LOGIN": "Bejelentkezés",
        "EMAIL": "Email",
        "LOGGINGIN": "Bejelentkezés ...",
        "LOGGEDIN": "Bejelentkezve",
        "ROLE": "Jogosultság",
        "FIRST_NAME": "Keresztnév",
        "LAST_NAME": "Vezetéknév",
        "COUNTRY": "Ország",
        "BIRTHDAY": "Születésnap",
        "MISC": "Egyéb",
        "ALLOW_NOTIFICATIONS": "Push üzenetek engedélyezése",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/hu/user.js